import React from "react";
import { useTranslation } from "react-i18next";
import { CircularProgress, Typography } from "@mui/material";
import Stack from "@mui/material/Stack";
import { useTaxSelector } from "../../redux/general/reduxStore";
import { CoreTaskQueue } from "@mm-products/java-multima-framework";

export default function BatchTaskIndicator() {
    const { t } = useTranslation();
    const tasks = useTaxSelector((state) => state.task.tasks);

    const runningTasks = React.useMemo(() => tasks.filter((t) => t.taskState === CoreTaskQueue.status.RUNNING), [tasks]);

    if (runningTasks.length === 0) {
        return null;
    }
    return (
        <Stack direction="row" alignItems="center" spacing={1}>
            <Typography variant="caption" color="black">
                {t("common.batch.running", { count: runningTasks.length })}
            </Typography>
            <CircularProgress size="20px" />;
        </Stack>
    );
}
